import Representatives from './Representatives'
import Brands from './Brands'
import Cashings from './Cashings/Cashings'
import BeneficialOwners from './BeneficialOwners'
import Documents from './Documents'
// import Messages from './Messages'
import Alerts from './Alerts'
import ValidationRequets from "./ValidationRequests/ValidationRequests"
import Invoices from './Invoices'
import OrdersTab from './OrdersTab'
import MailScan from './MailScan'
import Hotline from './Hotline'
import LoyaltyProgramsSubscriptions from './LoyaltyProgramsSubscriptions'

const tabs = [
    {
        name: "informations",
        display_name: "Informations",
        alternative_name: "Contrat"
    },
    {
        name: "orders",
        display_name: "Commandes",
        component: OrdersTab
    },
    {
        name: 'representatives',
        display_name: 'Représentants',
        component: Representatives
    },
    {
        name: 'brands',
        display_name: 'Marques',
        component: Brands
    },
    {
        name:"beneficial-owners",
        display_name: 'Bénéficiaires effectifs',
        component: BeneficialOwners
    },
    {
        name:"documents",
        display_name: 'Documents',
        component: Documents
    },
    // {
    //   component: Messages,
    //   display_name: 'Messages',
    //   name: 'messages'
    // },
    {
        name: 'alerts',
        display_name: 'Alertes',
        component: Alerts
    },
    {
        name: 'invoices',
        display_name: 'Factures',
        component: Invoices
    },
    {
        name: 'validation-requests',
        display_name: "Demandes de validation",
        component: ValidationRequets
    },
    {
        name: 'cashings',
        display_name: 'Encaissements',
        component: Cashings
    },
    {
        name: 'mail-scan',
        display_name: 'Scan',
        component: MailScan
    },
    {
        name: 'hotline',
        display_name: 'Permanence tél.',
        component: Hotline,
        display_statement:true
    },
    {
        name: 'fidelity',
        display_name: 'Fidelité',
        component: LoyaltyProgramsSubscriptions
    },
]

export default tabs

export const moduleName = "customer"
export { TAB_ACTIVATION, TAB_ALTERNATIVE_ACTIVATION } from 'store/mutation-types'



// WEBPACK FOOTER //
// ./client/components/Customer/tabs.js